
import SETTINGS from 'settings'
import { TYPE } from 'network/network_api'

export default function()
{
    SETTINGS.bundles = SETTINGS.bundles || []

    //jackpot:
    SETTINGS.bundles.push( {
        name : 'jackpot',
        types : [ TYPE.JACKPOT ],
        graphics : [
            'res/common/fonts/jackpot-font.png',
            'res/common/fonts/jackpot-font.xml',
            'res/common/jackpot/jackpot_table.jpg',
            'res/common/jackpot/super_table.jpg',
            'res/common/jackpot/mega_table.jpg',
            'res/common/jackpot/persones_gold.png',
            'res/common/jackpot/pers_top_left.png',
            'res/common/jackpot/pers_top_right.png',
            'res/common/jackpot/persones_silver.png',
            'res/common/jackpot/persones_bronze.png',
            'res/common/jackpot/lamp/000.png',
            'res/common/jackpot/lamp/001.png',
            'res/common/jackpot/lamp/002.png',
            'res/common/jackpot/lamp/003.png',
            'res/common/jackpot/press_collect.png',
            'res/common/jackpot/you_won.png',
            'res/common/jackpot/jackpot_coin.json',
        ],
        sounds : [
            'res/common/sounds/jackpot/impact',
            'res/common/sounds/jackpot/intro',
            'res/common/sounds/jackpot/loop_0',
            'res/common/sounds/jackpot/loop_1',
            'res/common/sounds/jackpot/loop_2',
            'res/common/sounds/jackpot/take',
        ]
    } )

    //roulete:
    SETTINGS.bundles.push( {
        name : 'roulette',
        types : [ TYPE.PRECURSOR ],
        graphics : [
            'res/common/roulette/background.jpg',
            'res/common/roulette/arrow.png',
            'res/common/roulette/disc/disc_default.png',
            'res/common/roulette/disc/disc_blue.png',
            'res/common/roulette/disc/disc_green.png',
            'res/common/roulette/disc/disc_yellow.png',
            'res/common/roulette/roulette_blink.json',
            'res/common/roulette/press_start.png',
            'res/common/roulette/waiting.png',
            'res/common/roulette/roulette_digits.png',
            'res/common/roulette/roulette_digits.xml',
            'res/common/roulette/blue_substrate.png',
            'res/common/roulette/green_substrate.png',
            'res/common/roulette/yellow_substrate.png',
            'res/common/roulette/question_mark.png',
        ],
        sounds : [
            'res/common/sounds/roulette/bonus',
            'res/common/sounds/roulette/super_jackpot',
            'res/common/sounds/roulette/mega_jackpot',
            'res/common/sounds/roulette/jackpot',
            'res/common/sounds/roulette/impact',
            'res/common/sounds/roulette/gold',
            'res/common/sounds/roulette/end',
            'res/common/sounds/roulette/music',
        ]
    } )

    //progressive jackpot:
    SETTINGS.bundles.push( {
        name : 'progressive_jackpot',
        types : [ TYPE.PROGRESSIVE_JACKPOT ],
        graphics : [
            'res/common/progressive_jackpot/orange_sun.jpg',
            'res/common/progressive_jackpot/green_sun.jpg',
            'res/common/progressive_jackpot/diamond_background.jpg',
            'res/common/progressive_jackpot/jp_panel.png',
            'res/common/progressive_jackpot/jp_particles.json',
            'res/common/progressive_jackpot/fonts/jp_big_digits_font.xml',
            'res/common/progressive_jackpot/jp_blick.png',
            'res/common/progressive_jackpot/jp_blick_mask.png',
            'res/common/progressive_jackpot/jp_press_start.png',
        
            'res/common/progressive_jackpot/galaxy_background.jpg',
            'res/common/progressive_jackpot/jp_panel_galaxy.png',
            'res/common/progressive_jackpot/headlight00.png',
            'res/common/progressive_jackpot/headlight01.png',
            'res/common/progressive_jackpot/headlight02.png',
            'res/common/progressive_jackpot/headlight03.png',
        
            'res/common/progressive_jackpot/particles/sparks_big/0.png',
            'res/common/progressive_jackpot/particles/sparks_big/1.png',
            'res/common/progressive_jackpot/particles/sparks_big/2.png',
            'res/common/progressive_jackpot/particles/sparks_big/3.png',
            'res/common/progressive_jackpot/particles/sparks_big/4.png',
            'res/common/progressive_jackpot/particles/sparks_big/5.png',
        
            'res/common/progressive_jackpot/particles/sparks_small/0.png',
            'res/common/progressive_jackpot/particles/sparks_small/1.png',
            'res/common/progressive_jackpot/particles/sparks_small/2.png',
            'res/common/progressive_jackpot/particles/sparks_small/3.png',
            'res/common/progressive_jackpot/particles/sparks_small/4.png',
            'res/common/progressive_jackpot/particles/sparks_small/5.png',
        

            
            'res/common/progressive_jackpot/jp_credits_panel.png',
            'res/common/progressive_jackpot/fonts/jp_credits_font.xml',
        ],
        sounds : [
            'res/common/sounds/progressive_jackpot/coins/music',
            'res/common/sounds/progressive_jackpot/coins/sound',
        
            'res/common/sounds/progressive_jackpot/diamonds/music',
            'res/common/sounds/progressive_jackpot/diamonds/sound',
        
            'res/common/sounds/progressive_jackpot/dollars/music',
            'res/common/sounds/progressive_jackpot/dollars/sound',
        
            'res/common/sounds/progressive_jackpot/galaxy/music',
            'res/common/sounds/progressive_jackpot/galaxy/sound',
        
            'res/common/sounds/progressive_jackpot/intro',
            'res/common/sounds/progressive_jackpot/gain_up',
            'res/common/sounds/progressive_jackpot/gain_stop',
        ]
    } )
}




// WEBPACK FOOTER //
// ./src/library/bundles.es6